module.exports = __webpack_public_path__ + "static/media/mol_ret_cad_molson_primary_lockup_1C_rgb_V2.2a2e41fe.svg";